/* @flow */

import React from "react";
import { useData } from "crustate/react";
import { useTranslate } from "@awardit/react-use-translate";
import { MobileOnlyCarousel } from "@crossroads/shop-views/";
import { HomeData } from "state/data";
import type { CarouselItem } from "state/home";

import styles from "./styles.scss";

type Props = {
  useWrapper?: boolean,
};

const getCategoriesData = (homeData: { [string]: any }): Array<CarouselItem> => {
  if (homeData == null) {
    return [];
  }

  return (Object.values(homeData): Array<any>)
    .filter(entry => entry && Object.prototype.hasOwnProperty.call(entry, "carousel"))
    .map((entry: { carousel: CarouselItem }) => ({
      name: entry.carousel.name,
      url: entry.carousel.url,
      image: entry.carousel.image,
    }));
};

const CategorySection = ({ useWrapper = false }: Props): React$Node => {
  const home = useData(HomeData);
  const t = useTranslate();

  if (home.state !== "LOADED") {
    return null;
  }

  const items = getCategoriesData(home.data);

  if (items.length === 0) {
    return null;
  }

  if (useWrapper) {
    return (
      <div className={styles.wrapper}>
        <h2 className={styles.sectionTitle}>{t("HOMEVIEW.POPULAR_CATEGORIES")}</h2>
        <MobileOnlyCarousel
          items={items}
          getItemKey={item => item.url}
        />
      </div>
    );
  }

  return (
    <MobileOnlyCarousel
      items={items}
      getItemKey={item => item.url}
    />
  );
};

export default CategorySection;
